define('view/controller/sub/ClientInfoLayout',['require','marionette','lib/Utils'],function (require) {

    var Parent = require('marionette').LayoutView;
    var Utils = require('lib/Utils');

    /**
     * Client info form view
     *
     * @class ClientInfoLayout
     */
    return Parent.extend({

        template: '#client_info_view',

        regions: {
            'termsAndConditions': '#sb_terms_container'
        },
        ui: {
            'submitBtn': '#sb_submit',
            'input': ':input'
        },
        triggers: {
            'click @ui.submitBtn': 'save:client'
        },
        events: {
            'change @ui.input': 'setModelData'
        },

        modelEvents: {
            'invalid': 'render',
            'sync': 'render'
        },

        termsModel: null,

        initialize: function () {
            this.termsModel = this.getOption('termsModel');

            this.listenTo(this.termsModel, 'invalid', this.render);
        },

        setModelData: function (event) {
            var element = jQuery(event.target);

            var value = element.val();
            if (element.attr('name') === 'phone') {
                value = Utils.getClientPhoneValue(value);
            }

            this.model.set(element.attr('name'), value);
        },

        showTermsAndConditions: function (view) {
            this.termsAndConditions.show(view);
        },

        serializeData: function () {
            var data = _.extend(Parent.prototype.serializeData.apply(this), {
                form_title: this.getOption('formTitle'),
                form_sub_title: this.getOption('formSubTitle'),
                back_button_label: this.getOption('backButtonLabel'),
                back_button_link: this.getOption('backButtonLink'),
                submit_button_label: this.getOption('submitButtonLabel'),
                errors: this.model.validationError
            });

            var res = _.extend(data, Utils.getClientPhoneData(data.phone));
            if (res.client_phone) {
                res.phone = res.client_phone;
            }

            return res;
        }

    });

});
